import React from 'react'

import Home from '../components/home'

export default () => (
    <Home lang="en" />
)
